export default __webpack_public_path__ + "static/IN-9008_Lenses_4,3mm_auto_15m_tag-e8d01a7c9180dfd25b41bdcb08e3e8ea.webp";